// Fuseau horaire de Mayotte (UTC+3)
export const TZ = 'Indian/Mayotte';

/**
 * Formate une date en francais avec le fuseau de Mayotte.
 * @param {string|Date} d - date ISO ou objet Date
 * @param {object} opts - options Intl.DateTimeFormat (sans timeZone)
 * @returns {string}
 */
export function fmtDateTZ(d, opts = {}) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-FR', { timeZone: TZ, ...opts });
}

/**
 * Formate une heure en francais avec le fuseau de Mayotte.
 */
export function fmtTimeTZ(d, opts = {}) {
  if (!d) return '—';
  return new Date(d).toLocaleTimeString('fr-FR', { timeZone: TZ, ...opts });
}

/**
 * Formate date + heure courte (jour mois, hh:mm)
 */
export function fmtDateTimeTZ(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('fr-FR', {
    timeZone: TZ,
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Retourne la date du jour a Mayotte au format YYYY-MM-DD
 */
export function todayMayotte() {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ }).format(new Date());
  return parts; // en-CA gives YYYY-MM-DD
}

// ── Statut ouverture restaurant ───────────────────────────────────────────────

const DAYS_FR = ['dimanche','lundi','mardi','mercredi','jeudi','vendredi','samedi'];

function mayotteNow() {
  const now = new Date();
  // UTC+3 : Mayotte
  const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
  const d = new Date(utcMs + 3 * 3600000);
  return { dayFr: DAYS_FR[d.getDay()], minutes: d.getHours() * 60 + d.getMinutes() };
}

function toMin(t) {
  const [h, m] = (t || '00:00').split(':').map(Number);
  return h * 60 + m;
}

function inSlot(minutes, open, close) {
  return minutes >= toMin(open) && minutes < toMin(close);
}

/**
 * Calcule si un restaurant est ouvert en ce moment à Mayotte,
 * basé sur son weekly_schedule (ou opening_time/closing_time en fallback).
 * Respecte is_open_manual === false pour la fermeture forcée.
 */
export function computeIsOpen(restaurant) {
  if (!restaurant) return false;
  if (restaurant.is_open_manual === false) return false;

  const { dayFr, minutes } = mayotteNow();
  const ws = restaurant.weekly_schedule;

  if (ws && ws[dayFr]) {
    const s = ws[dayFr];
    if (s.closed) return false;
    if (!s.open || !s.close) return restaurant.is_open ?? true;
    const slot1 = inSlot(minutes, s.open, s.close);
    if (s.open2 && s.close2) return slot1 || inSlot(minutes, s.open2, s.close2);
    return slot1;
  }

  if (restaurant.opening_time && restaurant.closing_time) {
    return inSlot(
      minutes,
      restaurant.opening_time.substring(0, 5),
      restaurant.closing_time.substring(0, 5),
    );
  }

  return restaurant.is_open ?? true;
}
